/* eslint-disable react/display-name */
import React from 'react';

import {
  createPaginationContainer as relayCreatePaginationContainer,
  RelayPaginationProp,
  GraphQLTaggedNode,
  ConnectionConfig,
  Container,
} from 'react-relay';
import useLoadMore from './hooks';

type ComponentProps<Props> = Props & {
  relay?: RelayPaginationProp;
};

function withIsLoading<Props>(WrappedComponent: React.ComponentType<Props>) {
  return function ({ relay, ...rest }: { relay: RelayPaginationProp }): JSX.Element {
    const { isLoading, loadMore } = useLoadMore(relay.loadMore);
    return (
      <WrappedComponent
        {...(rest as Props)}
        relay={{
          ...relay,
          isLoading: () => isLoading,
          loadMore: loadMore,
        }}
      />
    );
  };
}

function createPaginationContainer<Props>(
  Component: React.ComponentType<ComponentProps<Props>>,
  fragmentSpec: Record<string, GraphQLTaggedNode>,
  connectionConfig: ConnectionConfig<Props>
): Container<Props> {
  return relayCreatePaginationContainer(
    withIsLoading<ComponentProps<Props>>(Component),
    fragmentSpec,
    connectionConfig
  );
}

export default createPaginationContainer;
